export { default } from './client-info';
